import React, { useEffect, useRef } from 'react';
import './PopupModal.css'; // Add styling for your modal

const PopupModal = ({ show, content, onClose }) => {
  const scrollPositionRef = useRef(0);

  // Add/remove body class to prevent background scrolling
  useEffect(() => {
    if (show) {
      // Store current scroll position
      scrollPositionRef.current = window.pageYOffset || document.documentElement.scrollTop;
      
      // Apply styles to prevent scrolling
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPositionRef.current}px`;
      document.body.style.width = '100%';
      document.body.style.height = '100%';
      
      // Prevent scroll on html element too
      document.documentElement.style.overflow = 'hidden';
      
    } else {
      // Restore scroll position
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.height = '';
      document.documentElement.style.overflow = '';
      
      // Restore scroll position
      window.scrollTo(0, scrollPositionRef.current);
    }
    
    // Cleanup on unmount
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.height = '';
      document.documentElement.style.overflow = '';
      
      if (scrollPositionRef.current) {
        window.scrollTo(0, scrollPositionRef.current);
      }
    };
  }, [show]);

  if (!show) return null;

  // Extract title from content
  const getTitle = () => {
    if (React.isValidElement(content)) {
      const h2Element = React.Children.toArray(content.props.children).find(
        child => React.isValidElement(child) && child.type === 'h2'
      );
      return h2Element ? h2Element.props.children : 'Information';
    }
    return 'Information';
  };

  // Remove title from content body
  const getBodyContent = () => {
    if (React.isValidElement(content)) {
      const children = React.Children.toArray(content.props.children);
      return children.filter(child => !(React.isValidElement(child) && child.type === 'h2'));
    }
    return content;
  };

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <div className="popup-header">
          <h2>{getTitle()}</h2>
          <button className="popup-close-button" onClick={onClose}>×</button>
        </div>
        <div className="popup-scrollable-content">
          <div className="popup-body">
            {getBodyContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupModal;
